module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [(_vm.$slots.buttonPlace) ? _c('SidebarElement', [_vm._t("buttonPlace")], 2) : _vm._e(), (_vm.$slots.afterButton) ? _c('div', {
    staticClass: "sidebar__after-button"
  }, [_vm._t("afterButton")], 2) : _vm._e(), (_vm.programmType) ? _c('SidebarElement', {
    attrs: {
      "title": "Вид программы"
    }
  }, [_vm._v(_vm._s(_vm.programmType))]) : _vm._e(), (_vm.educationCategory) ? _c('SidebarElement', {
    attrs: {
      "title": "Категория обучающихся"
    }
  }, [_vm._v(_vm._s(_vm.educationCategory))]) : _vm._e(), (_vm.educationMode) ? _c('SidebarElement', {
    attrs: {
      "title": "Режим обучения"
    }
  }, [_vm._v(_vm._s(_vm.educationMode))]) : _vm._e(), (_vm.eduDocName) ? _c('SidebarElement', {
    attrs: {
      "title": "Документ об обучении"
    }
  }, [_vm._v(_vm._s(_vm.eduDocName))]) : _vm._e(), (_vm.finishResult) ? _c('SidebarElement', {
    attrs: {
      "title": "Уровень квалификации"
    }
  }, [_vm._v(_vm._s(_vm.finishResult))]) : _vm._e(), _c('SidebarElement', {
    attrs: {
      "title": "Форма обучения",
      "inline": true
    }
  }, [_vm._v(_vm._s(_vm.educationForm))]), _c('SidebarElement', {
    attrs: {
      "title": "ОВЗ",
      "inline": true
    }
  }, [_c('YesNo', {
    attrs: {
      "value": _vm.isOvz
    }
  }), _c('BracketsList', {
    attrs: {
      "list": _vm.ovzDiseases
    }
  })], 1), _c('SidebarElement', {
    attrs: {
      "title": "Обучение с ДОТ",
      "inline": true,
      "inline-values-elements": true
    }
  }, [_c('YesNo', {
    attrs: {
      "value": _vm.isDot
    }
  }), _c('AppSvgIconNew', {
    staticClass: "ui_color__blue",
    attrs: {
      "template": _vm.$ui.IconSvgComponents.question,
      "color-mode": "stroke",
      "title": "Дистанционные образовательные технологии"
    }
  })], 1), (_vm.locations.length) ? _c('SidebarElement', {
    attrs: {
      "title": ("Мест" + (_vm.locations.length > 1 ? "а" : "о") + " обучения")
    }
  }, [_vm._l((_vm.locations), function(ref) {
    var location = ref.location;
    var lat = ref.lat;
    var lng = ref.lng;

    return [(lng && lat) ? _c('a', {
      staticClass: "place",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.$emit("show-place")
        }
      }
    }, [_vm._v(_vm._s(location))]) : _c('div', {
      staticClass: "place--without-coords"
    }, [_vm._v(_vm._s(location))])]
  })], 2) : _vm._e(), _c('SidebarElement', {
    attrs: {
      "title": "Метро"
    }
  }, [(_vm.metro) ? _c('div', {
    staticClass: "place"
  }, [_vm._v(_vm._s(_vm.metro))]) : _vm._e()]), (_vm.municipalityLink.length > 0) ? _c('SidebarElement', {
    attrs: {
      "title": "Муниципалитет"
    }
  }, [_vm._l((_vm.municipalityLink), function(link, index) {
    return [_c('ExtLink', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.municipalityName[index]),
        expression: "municipalityName[index]"
      }],
      staticClass: "me-2",
      attrs: {
        "to": link
      }
    }, [_vm._v(_vm._s(_vm.municipalityName[index]))])]
  })], 2) : _vm._e(), (_vm.cost) ? _c('SidebarElement', {
    attrs: {
      "title": "Стоимость"
    }
  }, [_vm._v(_vm._s(_vm.cost))]) : _vm._e(), _c('SidebarElement', {
    attrs: {
      "title": "Правообладатель"
    }
  }, [(_vm.partner) ? _c('ExtLink', {
    attrs: {
      "to": {
        path: ("/organization/" + (_vm.partner.id))
      }
    }
  }, [_vm._v(_vm._s(_vm.partner.name))]) : _vm._e()], 1), _c('Share', {
    attrs: {
      "initTitle": _vm.title
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a85918","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/sidebar/Sidebar.vue
// module id = 1787221073b5b4ba230c
// module chunks = 5